export const CPF_INVALIDO = "CPF_INVALIDO"; //arrumar isso aqui
export const NUMERO_MAXIMO = "ATINGIDO_NUMERO_MAXIMO_DE_FUNCIONARIOS_ATIVOS";
export const CPF_JA_CADASTRADO = "CPF_JA_CADASTRADO";
